export default "__VITE_ASSET__qqH8VKNQ__"